import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card-header d-flex"
}
const _hoisted_2 = { class: "flex-grow-1 fs-6 fw-normal" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = {
  key: 0,
  class: "h5 card-title"
}
const _hoisted_5 = { class: "card-text" }

import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'BCard',
  props: {
    header: {},
    title: {},
    variant: {}
  },
  setup(__props: any) {

const props = __props;

const className = computed(() => {
    if (!props.variant) {
        return null;
    }
    return `bg-${props.variant}`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card text-dark mb-3", className.value])
  }, [
    (__props.header)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h2", _hoisted_2, _toDisplayString(__props.header), 1),
          _createElementVNode("div", null, [
            _renderSlot(_ctx.$slots, "header")
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (__props.title)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_4, _toDisplayString(__props.title), 1))
        : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_5, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ], 2))
}
}

})